import CampoEnum from "../../domain/protocolo/CampoEnum";
import ProtocoloEnum from "../../domain/protocolo/ProtocoloEnum";

export default {
  computed: {
    ambienteAtual() {
      return this.$store.state.ambientes.atual;
    }
  },
  methods: {
    $isJuridica(formValues) {
      let protocolo =
        formValues.protocolo[ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO];
      if (!protocolo) {
        protocolo = this.formValues.protocolo[
          ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO_EAD
        ];
      }
      if (!protocolo && this.ambienteAtual.idAmbiente == 8) {
        protocolo = this.formValues.protocolo[
          ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO_MEDICINA
        ];
      }
      let campo = protocolo.campos[CampoEnum.TIPO_PESSOA];

      return campo == "juridica";
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/protocolo/verificaTipoPessoa.js